import {
  customerPendingLogRequest,
  deletePendingEmailRequest,
  emailTemplatesRequest,
  fetchReceiverEmailRequest,
  resendAllRequest,
  resendRequest,
  searchPendingLogRequest,
  wholesalerTamplateListRequest
} from '@cbgms/api/modules/customers/requests'
import { ApiResponse, DeleteEmailResponse, GETCompaniesResponse, ResendAllResponse, ResendEmailResponse } from '@cbgms/api'
import { IPaginatedRequest, IPaginatedRequestWholsaler } from '@cbgms/api/request'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const customerPendingLog = (params: IPaginatedRequest) => {
  return AsyncAction<GETCompaniesResponse>({
    type: [types.GET_CUSTOMERS_PENDING_LOG, types.GET_CUSTOMERS_PENDING_LOG_SUCCESS, types.GET_CUSTOMERS_PENDING_LOG_FAILED],
    payload: {
      api: 'support',
      request: customerPendingLogRequest(params)
    }
  })
}

export const wholesalerTamplateList = (params: IPaginatedRequestWholsaler) => {
  return AsyncAction<GETCompaniesResponse>({
    type: [types.GET_WHOLESALER_TAMPLATE_LOG, types.GET_WHOLESALER_TAMPLATE_SUCCESS, types.GET_WHOLESALER_TAMPLATE_FAILED],
    payload: {
      api: 'support',
      request: wholesalerTamplateListRequest(params)
    }
  })
}

export const searchPendingLog = (data: object) => {
  return AsyncAction<ApiResponses<CustomerEmailInterface[]>>({
    type: [types.SEARCH_PENDING_EMAIL_LOG, types.SEARCH_PENDING_EMAIL_LOG_SUCCESS, types.SEARCH_PENDING_EMAIL_LOG_FAILED],
    payload: {
      api: 'support',
      request: searchPendingLogRequest(data)
    }
  })
}

export const resendPendingEmail = (data: object) => {
  return AsyncAction<ResendEmailResponse>({
    type: [types.PENDING_EMAIL_LOG_SEND, types.SPENDING_EMAIL_LOG_SEND_SUCCESS, types.PENDING_EMAIL_LOG_SEND_FAILED],
    payload: {
      api: 'support',
      request: resendRequest(data)
    }
  })
}

export const resendAllPendingEmail = (data: string) => {
  return AsyncAction<ResendAllResponse>({
    type: [types.PENDING_EMAIL_LOG_SENDALL, types.SPENDING_EMAIL_LOG_SENDALL_SUCCESS, types.PENDING_EMAIL_LOG_SENDALL_FAILED],
    payload: {
      api: 'support',
      request: resendAllRequest(data)
    }
  })
}

export const deletePendingEmail = (data: string) => {
  return AsyncAction<DeleteEmailResponse>({
    type: [types.PENDING_EMAIL_LOG_DELETE, types.PENDING_EMAIL_LOG_DELETE_SUCCESS, types.PENDING_EMAIL_LOG_DELETE_FAILED],
    payload: {
      api: 'support',
      request: deletePendingEmailRequest(data)
    }
  })
}

export const fetchEmailTemplates = (appID: string) => {
  return AsyncAction<ApiResponse>({
    type: [types.FETCH_EMAIL_TEMPLATES, types.FETCH_EMAIL_TEMPLATES_SUCCESS, types.FETCH_EMAIL_TEMPLATES_FAILED],
    payload: {
      api: 'support',
      request: emailTemplatesRequest(appID)
    }
  })
}

export const fetchReceiverEmail = (data: string) => {
  return AsyncAction<any>({
    type: [types.PENDING_EMAIL_LOG_EMAIL_FETCH, types.PENDING_EMAIL_LOG_EMAIL_FETCH_SUCCESS, types.PENDING_EMAIL_LOG_EMAIL_FETCH_FAILED],
    payload: {
      api: 'support',
      request: fetchReceiverEmailRequest(data)
    }
  })
}

import { FiltrerAction } from './types'
import { ApiResponses, CustomerEmailInterface } from '@cbgms/api/modules/customers'

export const UPDATE_QUERY = 'UPDATE_QUERY'
export const UPDATE_MODULE_ID = 'UPDATE_MODULE_ID'
export const UPDATE_ACTIVATION_STATUS = 'UPDATE_ACTIVATION_STATUS'
export const UPDATE_TEMPLATE_NAME = 'UPDATE_TEMPLATE_NAME'
export const UPDATE_APP_ID = 'UPDATE_APP_ID'
export const RESET_FILTERS = 'RESET_FILTERS'

export function updateQuery(query: string): FiltrerAction {
  return { type: UPDATE_QUERY, payload: query }
}

export function updateAppId(appId: number): FiltrerAction {
  return { type: UPDATE_APP_ID, payload: appId }
}

export function updateModuleID(moduleID: string): FiltrerAction {
  if (moduleID === 'None') {
    moduleID = ''
  }
  return { type: UPDATE_TEMPLATE_NAME, payload: moduleID }
}

export function resetFilters(): FiltrerAction {
  return { type: RESET_FILTERS }
}
